import type { RoadmapDetailSummaryCreatorBasicInfo } from './roadmapDetailSummaryCreatorBasicInfo';
import type { RoadmapDetailSummaryCreatorSocial } from './roadmapDetailSummaryCreatorSocial';

/**
 * 로드맵 생성자 정보
 */
export type RoadmapDetailSummaryCreator = {
  /** 사용자 기본 정보 */
  basicInfo: RoadmapDetailSummaryCreatorBasicInfo;
  /** 소셜 관계 정보 */
  social?: RoadmapDetailSummaryCreatorSocial;
};
